<template>
  <AdminLayout :title="$t('admin_sale_log.sale_log_title')" :current="$c.ADMIN.TAB.LOGIN">
    <div class="section">
      <div class="container" style="width: 80%;">
        <b-input v-model="phone_num"
                 :formatter="Utils.formatPhoneNumber" style="margin-top: 59px;" class="admin-border mobile-input" :placeholder='$t("admin_member.mobile_phone")'></b-input>
        <b-button class="butsize unit" squared variant="none" @click="login">{{$t("login.login")}}</b-button>
        <b-input v-model="sale_num" type="number" style="margin-top: 50px" class="admin-border mobile-input" :placeholder='$t("admin_member.maemul_number")'></b-input>
        <b-button class="butsize unit" squared variant="none" @click="login_sale">{{$t("login.login")}}</b-button>
      </div>
    </div>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Utils from "../../../../config/utils";

export default {
  name: "AdminLogin",
  components: {
    AdminLayout,
    InputSearch
  },
  data() {
    return {
      Utils:Utils,
      phone_num:'',
      sale_num:'',
    }
  },
  methods:{
    login(){
      if(this.validate('PHONE',this.phone_num)){
        Utils.requestPost(
          this.$c.API.Auth.adminLogin,
          {
            phone_number: this.phone_num.replaceAll('-', ''),
            type: 'phone',
          }
        ).then(result => {
          if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            this.myinfo.accessToken = result.data.access_token;
            this.getProfile();
          } else {
            Utils.toast(this,result.msg);
          }
        });
      }
    },
    login_sale(){
      if(this.validate('SALE',this.sale_num)){
        Utils.requestPost(
          this.$c.API.Auth.adminLogin,
          {
            phone_number: this.sale_num,
            type: 'maemul',
          }
        ).then(async result => {
          if (result.code === this.$c.API_RES_CODE.SUCCESS) {
            this.myinfo.accessToken = result.data.access_token;
            this.getProfile();
          } else {
            Utils.toast(this,result.msg);
          }
        });
      }
    },
    getProfile(){
      Utils.requestGet(
        this.$c.API.User.getProfile,
        {}
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.transformData(result.data);
          this.myinfo.saveInfo();
          this.$router.push('/Home');
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    validate(type, data){
      if (data !== null){
        return true;
      }else{
        var txt;
        switch (type){
          case 'PHONE': txt = this.$t('login.phone_placeholder'); break;
          case 'SALE': txt = this.$t('login.maemul_placeholder'); break;
        }
        Utils.toast(this, txt);
        return false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';

.butsize{
  background-color: #267fff;
  height: 45px;
  color: white;
  font-size: 16px;
  font-family: $korean_gd_15_r;
  width: 100%;
}

.mobile-input{
  text-align: center;
  padding:0 12px;
  font-size: 16px;
  font-family: $korean_gd_13_r;
  height: 45px;
}

::placeholder{
  color: #858383;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminLogin.vue